/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  collapsed: 'is-collapsed',
  dark: 'is-dark',
  disabled: 'is-disabled',
  error: 'has-error',
  fixed: 'is-fixed',
  hidden: 'is-hidden',
  large: 'is-large',
  loading: 'is-loading',
  minimised: 'is-minimised',
  moved: 'is-moved',
  open: 'is-open',
  small: 'is-small',
  success: 'has-success',
  tabbable: 'is-tabbable',
  updating: 'is-updating',
  visible: 'is-visible',
}
